
<template>
  <ancestryline-modal title="protocol.tab-general.actions.print-budget"  id="protocol-printbudget-selection-modal" :close="true" @close="close" :loading="false">
    <card>
      <coff-input-select
        v-model="form.budgetConfiguration"
        :label="$t('protocol.tab-general.actions.print-budget-selection.budget-configuration')"
        class="p-col-12 p-mb-3"
        :options="budgetConfigurations"
        option-label="name"
        :error="validation.budgetConfiguration"
      />

      <coff-input-auto-complete 
        v-model="form.fullPackage" 
        :label="$t('protocol.tab-general.actions.print-budget-selection.pacote-completo')" 
        class="p-col-12 p-mb-3" 
        :itens="protocols" 
        field="displayName" 
        :func-suggestions="searchProtocol" 
        :error="validation.fullPackage"/>
      
      <coff-input-auto-complete 
        v-model="form.intermediatePackage" 
        :label="$t('protocol.tab-general.actions.print-budget-selection.pacote-intermediario')" 
        class="p-col-12 p-mb-3" 
        :itens="protocols" 
        field="displayName" 
        :func-suggestions="searchProtocol" 
        :error="validation.intermediatePackage"/>
      
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.tab-general.actions.print-budget')" @click="confirm" class="p-ml-2"/>
      </div>
    </template>
  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import BudgetConfigurationBusiness from "@/business/BudgetConfigurationBusiness";

export default {
  name: "ModalPrintBudgetSelection",

  props: {
    protocol: {type: Object, default: () => {return {}}},
  },

  async mounted() {
    // Protocols will be loaded via search as user types
    this.budgetConfigurations = await BudgetConfigurationBusiness.getAll() || [];
  },

  data(){
    return {
      form: {
        budgetConfiguration: null,
        fullPackage: null,
        intermediatePackage: null,
      },
      validation: {
        budgetConfiguration: false,
        fullPackage: false,
        intermediatePackage: false,
      },
      protocols: [],
      budgetConfigurations: [],
    }
  },

  methods:{

    close(){
      DialogService.closeModal();
    },

    confirm(){
      DialogService.closeModal({
        budgetConfiguration: this.form.budgetConfiguration || null,
        fullPackage: this.form.fullPackage?.id || null,
        intermediatePackage: this.form.intermediatePackage?.id || null,
      });
    },

    async searchProtocol(code){
      const results = await ProtocolBusiness.search(code);
      if(results) {
        return results.map(protocol => ({
          ...protocol,
          displayName: this.formatProtocolName(protocol)
        }));
      }
      return [];
    },

    formatProtocolName(protocol){
      if(protocol.budget) {
        return `${this.$t('forms.protocol.budget-title')} ${protocol.code}`;
      }
      return `${this.$t('forms.protocol.title')} ${protocol.code}`;
    }

  }
}
</script>
